import styled from "styled-components";
import { device } from "../../../themes/Breakpoints";

export const BadgesWrap = styled.div`
  width: 100%;
  max-width: 750px;
  //@media only screen and (max-width: 1249px) {
  //  //max-width: 650px;
  //}
`;

export const BadgesItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 33px;
  @media only screen and (max-width: 1249px) {
    gap:28px;
  }
  @media ${device.mobileL} {
    gap:18px;
  }
  @media ${device.mobileM} {
    gap:18px;
  }
  @media ${device.mobileS} {
    gap:18px;
  }
`;

export const BadgesCont = styled.div`
  &:last-child {
    margin-top: 44px;
  }
  @media ${device.mobileL} {
    &:last-child {
      margin-top: 24px;
    }
  }
  @media ${device.mobileM} {
    &:last-child {
      margin-top: 24px;
    }
  }
  @media ${device.mobileS} {
    &:last-child {
      margin-top: 24px;
    }
  }
`;
